function About() {
    return (
        <div style={{ height: "80vh", padding: "5% 20%", letterSpacing: "2px" }}>
            <h1>About Us</h1>
            <p>We are leading Alchohol & Non-Alchoholic Drinks vendor in South Asia. Name any drink we can supply it to your bar. We specialize in Fresh Drinks from the Farm. All the Drinks are vegetarian and Curated with high quality ingredients and lots of Love ❤</p>
        </div>
    );
}

export default About;